module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	methods: {
		onChange: function(){
			var self = this;
			self.model.filterByName = (((self.model.dirtyFields || {}).data || {}).attributes || {}).name || '';
			if(!self.model.tagAssignment){
				self.closest('templates_tags_tagAssignment', function(tagAssignment){
					self.model.tagAssignment = tagAssignment;
				});
			}
			if(self.model.tagAssignment){
				self.model.tagAssignment.filterByName(self.model.filterByName);
			}
		}
	}

}